// extracted by mini-css-extract-plugin
export default {"left":"rW2MP6neTQVWXvu2YcQk"};